<template>
  <el-dialog :title="form.id?'编辑商品分类':'新建商品分类'" :visible.sync="formVisible" width="600px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="上级商品分类" :prop="isParentid?'parentid':''" class="width100">
        <treeselect v-model="form.parentid" :disabled="form.id && !form.parentid" :options="menuOptions" :normalizer="normalizer" :show-count="true" noOptionsText="暂无数据" placeholder="请选择" />
      </el-form-item>
      <el-form-item label="分类名称" prop="name" class="width100">
        <el-input v-model="form.name" />
      </el-form-item>
      <el-form-item label="分类图标" prop="icon" class="width100">
        <imageUpload v-model="form.icon" width="36" height="36" />
        <!-- 活动图片将展示在个人中心的活动模块。 -->
      </el-form-item>
      <el-form-item label="展示位置" prop="sysGoodsAreaList" class="width100">
        <el-checkbox-group v-model="form.sysGoodsAreaList">
          <el-checkbox :label="3">余额</el-checkbox>
          <el-checkbox :label="4">零售价兑换专区</el-checkbox>
          <el-checkbox :label="5">学费赠送专区</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <el-form-item label="页面排序" prop="orderNo" class="width100">
        <el-input v-model="form.orderNo" />
      </el-form-item>
      <el-form-item label="描述" prop="described" class="width100">
        <el-input v-model="form.described" />
      </el-form-item>
      <el-form-item label="状态" prop="isEnable" class="width100">
        <el-switch v-model="form.isEnable" :active-value="true" :inactive-value="false"></el-switch>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsCategorizeApi from '@/api/goods/sysGoodsCategorize'
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import ImageUpload from "@/components/ImageUpload";
function initFormBean() {
  const formBean = {
    parentid: null,
    name: null,
    icon: null,
    orderNo: null,
    described: null,
    isEnable: false,
    sysGoodsAreaList: []
  }
  return formBean
}

export default {
  props: ['menuOptions'],
  components: { ImageUpload, Treeselect },
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        parentid: [{ required: true, message: '请选择上级商品分类', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商品分类名称', trigger: 'blur' }],
        // icon: [{ required: true, message: '请上传商品分类图标', trigger: 'change' }],
        orderNo: [{ pattern: /^[0-9]*$/, message: '必须为数字值', trigger: 'blur' }],
        isEnable: [{ required: true, message: '请选择状态', trigger: 'change' }],
      },
      isParentid: false,
      isRepSub: false
    }
  },
  created() {
  },
  methods: {
    /** 转换菜单数据结构 */
    normalizer(node) {
      if (node.child && !node.child.length) {
        delete node.child;
      }
      return {
        id: node.id,
        label: node.name,
        children: node.child
      };
    },
    /**
     * 重置表单
     */
    resetForm() {
      this.isParentid = false
      this.form = initFormBean()
    },
    /**
     * 打开新建表单
     */
    handleCreate(row) {
      this.resetForm()
      this.form.parentid = row.id || null
      if (row.id) this.isParentid = true
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    handleUpdate(row) {
      this.resetForm()
      this.form = { ...row }
      this.$set(this.form, 'sysGoodsAreaList', this.form.area.map(item => item.id))
      if (row.id && row.parentid) this.isParentid = true
      this.formVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    /**
     * 执行新建操作
     */
    doCreate() {
      let params = JSON.parse(JSON.stringify(this.form))
      params.orderNo = params.orderNo || 0
      // params.parentid = params.parentid || 0
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.isRepSub) return
          this.isRepSub = true
          if (this.form.id > 0) {
            sysGoodsCategorizeApi.update(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          } else {
            sysGoodsCategorizeApi.create(params).then((data) => {
              this.postCallback(data)
            }).catch(res => {
              this.isRepSub = false
            });
          }
        }
      });
    },
    postCallback(response) {
      this.isRepSub = false
      this.$message.success('操作成功')
      this.formVisible = false;
      this.$emit('created')
    },
  }
}
</script>
<style lang="scss" scoped>
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
